import React, { useEffect, useRef, useState } from "react";
import styles from "./SectionHome3Carrousel.module.scss";
import {
  Swiper,
  SwiperSlide,
} from "../../../node_modules/swiper/react/swiper-react.js";
import { Pagination } from "swiper";
import "../../../node_modules/swiper/swiper.scss";
import "../../../node_modules/swiper/modules/navigation/navigation.scss"; // Navigation module
import "../../../node_modules/swiper/modules/effect-cards/effect-cards.scss"; // Pagination module
import "../../../node_modules/swiper/modules/effect-creative/effect-creative.scss"; // Pagination module
import "../../../node_modules/swiper/modules/autoplay/autoplay.scss"; // Pagination module
import SldierArrowRight from "../../components/icons/SldierArrowRight.jsx";
import SliderArrowLeft from "../../components/icons/SliderArrowLeft.jsx";
import { Button } from "../../components/shared/Button.jsx";
import SVGDrawable from "./SVGDrawable.jsx";

import { animate, svg, stagger } from "animejs";
import SVGDrawableTwo from "./SVGDrawableTwo.jsx";
import SVGDrawableThree from "./SVGDrawableThree.jsx";
import SVGDrawableFour from "./SVGDrawableFour.jsx";
import ShopIcon from "../../components/icons/ShopIcon.jsx";
import { useNavigate } from "react-router-dom";

const SectionHome3Carrousel = () => {
  const swiperRef = useRef(null);
  const sectionRef = useRef(null); // referencia al contenedor
  const [startAnimation, setStartAnimation] = useState(false);
  const paginationRef = useRef(null);
  const navigate = useNavigate();

  const goNext = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slideNext();
    }
  };

  const goPrev = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slidePrev();
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setStartAnimation(true);
          handleAnimate1(); // Llama la animación
          observer.disconnect(); // Detiene el observer después de ejecutarse una vez
        }
      },
      {
        root: null, // viewport
        rootMargin: "0px",
        threshold: 0.5, // 50% visible
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const handleAnimate1 = () => {
    animate(svg.createDrawable(".line"), {
      draw: ["0 1"],
      opacity: 1,
      easing: "easeInOutQuad",
      duration: 2000,
      delay: stagger(100),
      loop: false,
    });
  };

  useEffect(() => {
    if (swiperRef.current && swiperRef.current.params) {
      swiperRef.current.params.pagination.el = paginationRef.current;
      swiperRef.current.pagination.init();
      swiperRef.current.pagination.render();
      swiperRef.current.pagination.update();
    }
  }, []);

  const params = {
    pagination: {
      el: ".custom-pagination-home-desktop",
      clickable: true,
    },
  };

  return (
    <div id="sectionHome3Carrousel" className={styles.wrapper} ref={sectionRef}>
      <div className={styles.carrousel}>
        <Swiper
          ref={swiperRef}
          slidesPerView={1}
          centeredSlides={true}
          modules={[Pagination]}
          {...params}
        >
          <SwiperSlide>
            <div className={styles.svgOne}>
              <SVGDrawable opacityOne={startAnimation} text={startAnimation} />
            </div>
            <div className={styles.svgTwo}>
              <SVGDrawableTwo
                opacityOne={startAnimation}
                text={startAnimation}
              />
            </div>
            <div className={styles.svgThree}>
              <SVGDrawableThree
                opacityOne={startAnimation}
                text={startAnimation}
              />
            </div>
            <div className={styles.svgFour}>
              <SVGDrawableFour
                opacityOne={startAnimation}
                text={startAnimation}
              />
            </div>
            <img src="/homepage/FancySlideMona-Desktop.png" alt="mona" />
          </SwiperSlide>
          <SwiperSlide>
            <img
              className="two"
              src="/homepage/Fancy_Monas-x9.png"
              alt="mona"
            />
          </SwiperSlide>
          <SwiperSlide>
            <img
              className="three"
              src="/homepage/Fancy_Monas-detalle.png"
              alt="mona"
            />
          </SwiperSlide>
          <div className={styles.buttonPrev} onClick={goPrev}>
            <SliderArrowLeft />
          </div>
          <div className={styles.buttonNext} onClick={goNext}>
            <SldierArrowRight />
          </div>
        </Swiper>
      </div>
      <div className="custom-pagination-home-desktop"></div>

      <div className={styles.callAction}>
        <h2>
          Elegí tu <br />
          <span>FANCY MONA</span>
        </h2>
        <Button
          onClick={() => navigate("/collection")}
          className={styles.buttonShop}
        >
          <ShopIcon />
          Shop
        </Button>
      </div>
    </div>
  );
};

export default SectionHome3Carrousel;
